exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n.page section{\r\n    margin: 50px 10px 30px;\r\n  }\r\n  \r\n.page section.card .error-code {\r\nmargin: 30px 0;\r\ncolor: #2d353c;\r\nfont-size: 96px;\r\nline-height: 100px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/homePC/angular-comp/The-Top/src/app/error/not-found/not-found.component.css
// module id = ../../../../../src/app/error/not-found/not-found.component.css
// module chunks = main